import React from "react";
import SVGIcon, { IconProps } from "ui/SVGIcon";

const path =
  "M1.70898 8.99971H12.879L7.99898 13.8797C7.60898 14.2697 7.60898 14.9097 7.99898 15.2997C8.38898 15.6897 9.01898 15.6897 9.40898 15.2997L15.999 8.70971C16.389 8.31971 16.389 7.68971 15.999 7.29971L9.41898 0.699712C9.23215 0.512459 8.9785 0.407227 8.71398 0.407227C8.44947 0.407227 8.19582 0.512459 8.00898 0.699712C7.61898 1.08971 7.61898 1.71971 8.00898 2.10971L12.879 6.99971H1.70898C1.15898 6.99971 0.708984 7.44971 0.708984 7.99971C0.708984 8.54971 1.15898 8.99971 1.70898 8.99971Z";

export default function ForwardArrowIcon(props: IconProps) {
  return <SVGIcon path={path} {...props} viewBox="-5 -5 24 24" />;
}
